import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Content, Bound, Row, Col } from "../components/layouts"
import PageIntro from "../components/pageIntro"
import Form from "../components/form"
import MenuReset from "../components/MenuReset"

const ContactPage = ({ data }) => (
  <Layout solidHeader>
    <SEO title="Contact" />
    <MenuReset />

    <PageIntro>
      <h2>Contact</h2>
    </PageIntro>

    <Content>
      <Row>
        <Col>
          <Bound>
            <address>
              <p>
                <a
                  href="https://maps.app.goo.gl/E7YsaJNwCZv1eFPf7"
                  title="address"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  32 Moffat Crescent, Hoppers Crossing, 3029{" "}
                </a>
              </p>
            </address>
            <p>Phone: 0413 078 633</p>
            <p>
              Email:{" "}
              <a
                href="mailto:clinic@fullyactivated.com.au"
                title="clinic@fullyactivated.com.au"
              >
                clinic@fullyactivated.com.au
              </a>
            </p>
            <p>
              If you would like more information or want to book an appointment,
              use the form on the right and we will get in contact with you.
              Alternatively, you can give us a call on 0413 078 633.
            </p>
            <h3>Hours</h3>
            <ul>
              <li>Monday 8am-11am, 3pm - 7pm</li>
              <li>Tuesday 8am-11am, 3pm - 7pm</li>
              <li>Wednesday 8am-11am, 3pm - 7pm</li>
              <li>Thursday 8am-11am, 3pm - 7pm</li>
              <li>Friday Closed</li>
              <li>Saturday 7am-12 noon</li>
            </ul>
          </Bound>
        </Col>
        <Col id="form">
          <a href={data.staticMap.mapUrl} target="_blank" rel="noreferrer">
            <Img fluid={data.staticMap.childFile.childImageSharp.fluid} />
          </a>
          <br />
          <Form name="enquiry" />
        </Col>
      </Row>
    </Content>
  </Layout>
)

export default ContactPage

export const query = graphql`
  query {
    staticMap {
      mapUrl
      childFile {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`
